import i18next from 'i18next';

import enCommon from './locales/en/common.json';
import enExternal from './locales/en/external.json';
import enImpact from './locales/en/impact.json';
import enMessages from './locales/en/messages.json';
import enOrganisation from './locales/en/organisation.json';
import enProject from './locales/en/project.json';
import enProjectFestival from './locales/en/project-festival.json';
import enProjectTour from './locales/en/project-tour.json';
import enProjectVenue from './locales/en/project-venue.json';
import enReport from './locales/en/report.json';
import frCommon from './locales/fr/common.json';
import frExternal from './locales/fr/external.json';
import frImpact from './locales/fr/impact.json';
import frMessages from './locales/fr/messages.json';
import frOrganisation from './locales/fr/organisation.json';
import frProject from './locales/fr/project.json';
import frProjectFestival from './locales/fr/project-festival.json';
import frProjectTour from './locales/fr/project-tour.json';
import frProjectVenue from './locales/fr/project-venue.json';
import frReport from './locales/fr/report.json';

const frNs1 = {
  ...frCommon,
  ...frExternal,
  ...frImpact,
  ...frMessages,
  ...frOrganisation,
  ...frProject,
  ...frProjectFestival,
  ...frProjectTour,
  ...frProjectVenue,
  ...frReport,
};

const enNs1 = {
  ...enCommon,
  ...enExternal,
  ...enImpact,
  ...enMessages,
  ...enOrganisation,
  ...enProject,
  ...enProjectFestival,
  ...enProjectTour,
  ...enProjectVenue,
  ...enReport,
};

export type AppLanguage = 'fr' | 'en';
export type AppLocale = 'fr-FR' | 'en-US';

const { language, appLocale } = defineAppLanguage();

i18next.init({
  lng: language,
  fallbackLng: 'fr',
  defaultNS: 'ns1',
  // debug: true,
  resources: {
    fr: {
      ns1: frNs1,
    },
    en: {
      ns1: enNs1,
    },
  },
});

const translate = i18next.t;

export { appLocale, language, translate };

function defineAppLanguage(): { language: AppLanguage; appLocale: AppLocale } {
  const lang = getLanguageFromLocalStorage();
  switch (lang) {
    case 'fr':
      return { language: 'fr', appLocale: 'fr-FR' };
    case 'en':
      return { language: 'en', appLocale: 'en-US' };
    default:
      return { language: 'fr', appLocale: 'fr-FR' };
  }
}

function getLanguageFromLocalStorage(): AppLanguage | null {
  const item = localStorage.getItem('app-lang');
  if (item === 'fr' || item === 'en') {
    return item as AppLanguage;
  }
  return null;
}

export function changeAppLanguageAndReload(lang: AppLanguage): void {
  saveLanguageToLocalStorage(lang);
  window.location.reload();
}

function saveLanguageToLocalStorage(lang: AppLanguage): void {
  localStorage.setItem('app-lang', lang);
}
